import React from "react";
import PropTypes from "prop-types";
import { Outlet } from "react-router-dom";

const NonAuthLayout = props => {
  return (
    <React.Fragment>
      <Outlet />
    </React.Fragment>
  );
};

NonAuthLayout.propTypes = {
  children: PropTypes.any,
  location: PropTypes.object,
};

export default NonAuthLayout;
